export const MOVABLE_WINDOWS_OPTIONS = [
  { label: '3 meses', value: '3' },
  { label: '6 meses', value: '6' },
  { label: '12 meses', value: '12' },
  { label: '24 meses', value: '24' },
  { label: '36 meses', value: '36' },
  { label: '48 meses', value: '48' },
  { label: '60 meses', value: '60' },
];
